import React, { useEffect, useState } from 'react'

function Profile() {
  const [user, setUser] = useState(null)

  useEffect(() => {
    try {
      const currentUser = JSON.parse(localStorage.getItem('CurrentUser') || 'null')
      setUser(currentUser)
    } catch (e) {
      setUser(null)
    }
  }, [])

  const displayName = () => {
    if (!user) return 'User'
    if (user.firstName || user.lastName) return `${user.firstName || ''} ${user.lastName || ''}`.trim()
    return user.name || user.email || 'User'
  }

  const initials = () => {
    const name = displayName()
    const parts = name.split(' ').filter(Boolean)
    return (parts[0]?.[0] || 'U').toUpperCase() + (parts[1]?.[0] || '').toUpperCase()
  }

  return (
    <div className="py-6">
      <div className=" px-4 sm:px-6 lg:px-8">
        {/* Header Card */}
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
          <div className="h-28 bg-gradient-to-r from-slate-100 to-white" />
          <div className="px-6 pb-6 -mt-12">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
              <div className="flex items-end gap-4">
                <div className="w-24 h-24 rounded-2xl bg-slate-100 border border-slate-200 flex items-center justify-center text-slate-800 font-semibold text-2xl">
                  {initials()}
                </div>
                <div>
                  <h1 className="text-2xl md:text-3xl font-semibold text-slate-900">{displayName()}</h1>
                  <p className="text-slate-500 text-sm md:text-base">{user?.email}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <button className="px-4 py-2 rounded-lg bg-gradient-to-r from-primary to-secondary text-white text-sm hover:opacity-90 shadow-sm">Edit Profile</button>
                <button className="px-4 py-2 rounded-lg border border-slate-200 text-slate-700 text-sm hover:bg-slate-50">Change Password</button>
              </div>
            </div>
          </div>
        </div>

        {/* Details Grid */}
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6">
            <h2 className="text-sm font-semibold text-slate-900 mb-4">Personal Information</h2>
            <div className="space-y-3 text-sm">
              <div className="flex justify-between"><span className="text-slate-500">Name</span><span className="text-slate-900">{displayName()}</span></div>
              <div className="flex justify-between"><span className="text-slate-500">Email</span><span className="text-slate-900">{user?.email || '-'}</span></div>
              <div className="flex justify-between"><span className="text-slate-500">Phone</span><span className="text-slate-900">{user?.phone || user?.contactNumber || '-'}</span></div>
              <div className="flex justify-between"><span className="text-slate-500">City</span><span className="text-slate-900">{user?.city || '-'}</span></div>
              <div className="flex justify-between"><span className="text-slate-500">Address</span><span className="text-slate-900">{user?.address || '-'}</span></div>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6">
            <h2 className="text-sm font-semibold text-slate-900 mb-4">Account</h2>
            <div className="space-y-3 text-sm">
              <div className="flex justify-between"><span className="text-slate-500">Role</span><span className="text-slate-900">{user?.roleName || (user?.role === 1 ? 'Super Admin' : user?.role === 2 ? 'Admin' : 'User')}</span></div>
              <div className="flex justify-between"><span className="text-slate-500">Status</span><span className="text-slate-900">{user?.isActive ? 'Active' : 'Inactive'}</span></div>
              <div className="flex justify-between"><span className="text-slate-500">Onboarding</span><span className="text-slate-900">{user?.isOnboarding ? 'Completed' : 'Pending'}</span></div>
              {/* <div className="flex justify-between"><span className="text-slate-500">User ID</span><span className="text-slate-900">{user?._id || user?.id || '-'}</span></div> */}
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 md:col-span-2">
            <h2 className="text-sm font-semibold text-slate-900 mb-4">Preferences</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="flex items-center justify-between p-3 rounded-lg border border-slate-200">
                <span className="text-sm text-slate-700">Email Notifications</span>
                <span className="text-xs px-2 py-1 rounded-full bg-slate-100 text-slate-700">Default</span>
              </div>
              <div className="flex items-center justify-between p-3 rounded-lg border border-slate-200">
                <span className="text-sm text-slate-700">Language</span>
                <span className="text-xs px-2 py-1 rounded-full bg-slate-100 text-slate-700">English</span>
              </div>
              <div className="flex items-center justify-between p-3 rounded-lg border border-slate-200">
                <span className="text-sm text-slate-700">Theme</span>
                <span className="text-xs px-2 py-1 rounded-full bg-slate-100 text-slate-700">Light</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Profile